// src/services/BulkPublishEmailTemplate.js

export const getBulkPublishEmailTemplate = ({
  recipientName,
  cycleCode,
  startDate,
  endDate,
  publishedOn,
  loginLink,
  showViewButton = true
}) => {
  const finalLoginUrl = loginLink || 
    (typeof window !== 'undefined'
      ? (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
        ? 'http://localhost:3000/login'
        : `${window.location.origin}/login`
      : 'https://capabilityindex.criticalriver.com/login'
    );

  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Review Results Published - ${cycleCode}</title>
</head>
<body style="margin:0; padding:0; background:#f8fafc; font-family:'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;">
  <table role="presentation" width="100%" style="background:#f8fafc; padding:40px 20px;">
    <tr>
      <td align="center">

        <!-- TEST EMAIL BANNER -->
        <table role="presentation" width="600" style="max-width:600px; margin-bottom:20px;">
          <tr>
            <td align="center" style="padding:20px;">
              <div style="
                background:#dc2626; 
                color:white; 
                padding:18px 40px; 
                border-radius:12px; 
                font-weight:700; 
                font-size:20px; 
                display:inline-block;
                box-shadow:0 6px 20px rgba(220,38,38,0.4);
                letter-spacing:0.5px;
              ">
                THIS IS A TEST EMAIL – PLEASE IGNORE
              </div>
            </td>
          </tr>
        </table>

        <!-- Main Email Card -->
        <table role="presentation" width="600" style="max-width:600px; background:#ffffff; border-radius:16px; overflow:hidden; box-shadow:0 10px 30px rgba(0,0,0,0.08);">
          
          <!-- Header -->
          <tr>
            <td style="background:#4f46e5; color:#ffffff; padding:44px 30px; text-align:center;">
              <h1 style="margin:0 0 8px; font-size:28px; font-weight:700; letter-spacing:-0.5px;">
                Review Results Published
              </h1>
              <p style="margin:0; font-size:17px; opacity:0.95;">
                Cycle <strong>${cycleCode}</strong> is now live
              </p>
            </td>
          </tr>

          <!-- Body -->
          <tr>
            <td style="padding:40px; color:#1f2937; line-height:1.6;">
              <p style="font-size:17px; margin:0 0 20px;">
                Dear <strong style="color:#4f46e5;">All</strong>,
              </p>

              <p style="font-size:15px; margin:0 0 24px; color:#374151;">
                The performance review cycle <strong>${cycleCode}</strong> has been officially published. Your review results are now available in the <strong>Capability Index</strong> portal.
              </p>

              <p style="font-size:15px; margin:0 0 32px; color:#374151;">
                You can now log in to view your performance review, feedback, and ratings.
              </p>

              <!-- Cycle Details -->
              <table role="presentation" width="100%" style="background:#f8fafc; border:1px solid #e2e8f0; border-radius:12px; margin:32px 0;">
                <tr>
                  <td style="padding:24px;">
                    <h3 style="margin:0 0 16px; font-size:17px; font-weight:700; color:#1e2937;">Cycle Details</h3>
                    <table role="presentation" width="100%" style="font-size:14px;">
                      <tr>
                        <td style="padding:7px 0; color:#64748b; font-weight:600; width:42%;">Cycle Code</td>
                        <td style="padding:7px 0; color:#1e2937; font-weight:600; text-align:right;">${cycleCode}</td>
                      </tr>
                      <tr>
                        <td style="padding:7px 0; color:#64748b; font-weight:600;">Review Period</td>
                        <td style="padding:7px 0; color:#1e2937; font-weight:600; text-align:right;">${startDate} – ${endDate}</td>
                      </tr>
                      <tr>
                        <td style="padding:7px 0; color:#64748b; font-weight:600;">Published On</td>
                        <td style="padding:7px 0; color:#1e2937; font-weight:600; text-align:right;">${publishedOn}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>

              <!-- Login Button -->
              ${showViewButton ? `
              <!-- Login Button -->
              <table role="presentation" width="100%" style="margin:40px 0;">
                <tr>
                  <td align="center">
                    <a href="${finalLoginUrl}"
                       style="display:inline-block; background:#4f46e5; color:#ffffff; text-decoration:none; padding:16px 48px; border-radius:12px; font-size:16px; font-weight:700; box-shadow:0 6px 18px rgba(79,70,229,0.35);">
                      View My Review in Capability Index
                    </a>
                  </td>
                </tr>
              </table>
` : ''}

              <p style="font-size:14px; color:#6b7280; margin:32px 0 0; line-height:1.6;">
                If you have any questions about your review or need to discuss the feedback, please reach out to your manager directly.
              </p>

              <p style="font-size:15px; margin:28px 0 0; color:#374151;">
                Thank you,<br>
                <strong style="color:#4f46e5;">Capability Index Team</strong>
              </p>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background:#f9fafb; padding:28px; text-align:center; border-top:1px solid #e5e7eb; font-size:13px; color:#9ca3af;">
              <p style="margin:0 0 8px;">This is an automated notification from the Capability Index System.</p>
              <p style="margin:0;">© 2025 Critical River. All rights reserved.</p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  `.trim();
};